export default __webpack_public_path__ + "static/media/010_home.first.fb72cc13.webp";